import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PassingThroughGateSection from './components/PassingThroughGateSection';
import CurrentPositionSection from './components/CurrentPositionSection';
import TriRootingSpiralSection from './components/TriRootingSpiralSection';
import LivingAbilityWheel from './components/LivingAbilityWheel';
import MyTreasuresSection from './components/MyTreasuresSection';
import NextLivingNodeSection from './components/NextLivingNodeSection';
import LifeResponseSection from './components/LifeResponseSection';
import FrequencyCalibrationSection from './components/FrequencyCalibrationSection';
import LivingQuestionsSection from './components/LivingQuestionsSection';
import AngelMemorySection from './components/AngelMemorySection';
import { useTranslation } from 'react-i18next';
import i18n from '@/i18n';

export default function Journey() {
  const { t } = useTranslation();

  const abilities: string[] = i18n.getResource(
    i18n.language,
    'translation',
    'journey.abilityRestoration.abilities'
  ) as string[] || ['承擔', '誠信', '覺知', '感恩'];

  const abilitiesEn: string[] = i18n.getResource(
    i18n.language,
    'translation',
    'journey.abilityRestoration.abilitiesEn'
  ) as string[] || ['Accountability', 'Integrity', 'Awareness', 'Gratitude'];

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />

      {/* Page identity — subtle header */}
      <div className="pt-16 md:pt-20 pb-6 md:pb-8 text-center bg-background-50">
        <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 mb-2">
          {t('journey.title')}
        </p>
        <p className="text-sm text-foreground-500 italic">
          {t('journey.subtitle')}
        </p>
        <p className="text-xs text-foreground-400 mt-1">
          {t('journey.subtitleZh')}
        </p>
      </div>

      <main>
        {/* 1. Passing Through the Revolving Gate — the core revelation */}
        <PassingThroughGateSection />

        {/* Divider */}
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <div className="border-t border-foreground-100" />
        </div>

        {/* 2. Where Am I Now? */}
        <CurrentPositionSection />

        {/* 3. What Abilities Am I Restoring? */}
        <section className="w-full bg-background-100/50">
          <div className="max-w-5xl mx-auto px-4 md:px-6 py-10 md:py-14">
            <h2
              className="text-lg md:text-xl text-foreground-800 mb-2 text-center"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              {t('journey.abilityRestoration.title')}
              <span className="block text-xs text-foreground-400 font-normal mt-1">
                {t('journey.abilityRestoration.titleEn')}
              </span>
            </h2>
            <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3 mt-6">
              {abilities.map((ab: string, idx: number) => (
                <span
                  key={ab}
                  className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-50 border border-foreground-200/50 text-sm text-foreground-600 hover:border-primary-200 hover:text-primary-700 transition-colors cursor-default"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-400" />
                  {ab}
                  <span className="text-[10px] text-foreground-400">
                    {abilitiesEn[idx]}
                  </span>
                </span>
              ))}
            </div>
          </div>
        </section>

        {/* 4. Tri-rooting Spiral */}
        <TriRootingSpiralSection />

        {/* 5. Living Ability Wheel */}
        <LivingAbilityWheel />

        {/* 6. My Treasures */}
        <MyTreasuresSection />

        {/* 7. Next Living Node */}
        <NextLivingNodeSection />

        {/* Divider */}
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <div className="border-t border-foreground-100" />
        </div>

        {/* 8. Living Frequency Calibration (NEW) */}
        <FrequencyCalibrationSection />

        {/* 9. Living Questions (NEW) */}
        <LivingQuestionsSection />

        {/* 10. Angel Memory (NEW) */}
        <AngelMemorySection />

        {/* 11. Life Response */}
        <LifeResponseSection />

        {/* Spacer for floating Angel bar */}
        <div className="h-20" />
      </main>

      <Footer />
    </div>
  );
}